import { render, staticRenderFns } from "./Confetti.vue?vue&type=template&id=130ed673&scoped=true&"
import script from "./Confetti.vue?vue&type=script&lang=js&"
export * from "./Confetti.vue?vue&type=script&lang=js&"
import style0 from "./Confetti.vue?vue&type=style&index=0&id=130ed673&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130ed673",
  null
  
)

export default component.exports